var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partnet-point-show"
  }, [_vm.fetching ? _c('p', [_c('Loading')], 1) : [_c('div', {
    staticClass: "partnet-point-show__header d-flex justify-content-between align-items-center"
  }, [_c('button', {
    staticClass: "s-p-3",
    on: {
      "click": function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "9",
      "height": "16",
      "viewBox": "0 0 9 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.28033 0.46967C8.5466 0.735936 8.5708 1.1526 8.35295 1.44621L8.28033 1.53033L1.811 8L8.28033 14.4697C8.5466 14.7359 8.5708 15.1526 8.35295 15.4462L8.28033 15.5303C8.01406 15.7966 7.5974 15.8208 7.30379 15.6029L7.21967 15.5303L0.21967 8.53033C-0.0465965 8.26406 -0.0708027 7.8474 0.147052 7.55379L0.21967 7.46967L7.21967 0.46967C7.51256 0.176777 7.98744 0.176777 8.28033 0.46967Z",
      "fill": "#666666"
    }
  })])]), _c('div', [_vm._v("異業點數交換")]), _c('div', {
    staticClass: "s-p-3"
  })]), _c('div', {
    staticClass: "s-p-3 min-vh-100"
  }, [_c('Item', {
    attrs: {
      "item": _vm.item
    }
  }), _vm.step === 'init' ? [_vm._m(0)] : _vm._e(), _vm.step === 'confirm' ? [_c('div', {
    staticClass: "divider mt-2"
  }, [_vm._v("兌換序號")]), _vm._l(_vm.sns, function (i, idx) {
    return _c('div', {
      key: idx,
      staticClass: "s-bg-white rounded rounded-2 d-flex align-items-center justify-content-between p-2 mb-1"
    }, [_c('div', {
      staticClass: "font-weight-bold flex-fill text-center"
    }, [_vm._v(_vm._s(i))]), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.click",
        value: '已複製',
        expression: "'已複製'",
        modifiers: {
          "click": true
        }
      }],
      staticClass: "s-btn s-btn-primary s-btn-sm s-text-xs w-auto text-nowrap py-2 px-3"
    }, [_vm._v("複製")])]);
  })] : _vm._e()], 2), _c('div', {
    staticClass: "footer p-3"
  }, [_vm.step === 'init' ? [_vm._m(1), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "mr-3 flex-fill"
  }, [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-redeem-solution",
      modifiers: {
        "modal-redeem-solution": true
      }
    }],
    staticClass: "s-btn s-btn-sm px-4 partnet-point-show__redeem-solution"
  }, [_vm._v(_vm._s(_vm.redeemSolution))]), _c('b-modal', {
    attrs: {
      "id": "modal-redeem-solution",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('div', [_vm._v("選擇兌換方案")]), _c('b-button', {
          staticClass: "close",
          attrs: {
            "variant": "link"
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('svg', {
          attrs: {
            "width": "24",
            "height": "24",
            "viewBox": "0 0 24 24",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
            "fill": "#666666"
          }
        })])])];
      }
    }, {
      key: "modal-footer",
      fn: function fn(_ref2) {
        var close = _ref2.close;
        return [_c('div', {
          staticClass: "w-100"
        }, [_c('button', {
          staticClass: "s-btn s-btn-primary s-btn-sm px-4",
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_vm._v("確認")])])];
      }
    }], null, false, 2091863710)
  }, [_c('div', {
    staticClass: "px-3 pt-3"
  }, _vm._l(['50 點 → 50 點', '200 點 → 220 點', '500 點 → 600 點'], function (i, idx) {
    return _c('b-form-radio', {
      key: idx,
      staticClass: "mb-3",
      attrs: {
        "value": i
      },
      model: {
        value: _vm.redeemSolution,
        callback: function callback($$v) {
          _vm.redeemSolution = $$v;
        },
        expression: "redeemSolution"
      }
    }, [_vm._v(_vm._s(i))]);
  }), 1)])], 1), _c('div', [_c('b-form-spinbutton', {
    attrs: {
      "min": "1",
      "max": "100"
    }
  })], 1)]), _c('div', {
    staticClass: "text-center my-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "sm",
      "value": "accepted"
    }
  }, [_vm._v(" 我已同意注意事項 ")])], 1), _c('button', {
    staticClass: "s-btn s-btn-primary s-btn-sm px-4",
    on: {
      "click": _vm.redeem
    }
  }, [_vm._v("確認")])] : _vm._e(), _vm.step === 'confirm' ? [_c('button', {
    staticClass: "s-btn s-btn-primary s-btn-sm px-4"
  }, [_vm._v("完成")])] : _vm._e()], 2)]], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partnet-point-show__info"
  }, [_c('ul', {
    staticClass: "partnet-point-show__info__range"
  }, [_c('li', [_vm._v("兌換活動期間：2025/01/01 - 2025/06/30")]), _c('li', [_vm._v("序號兌換效期：2025/01/01 - 2025/12/31")])]), _c('div', {
    staticClass: "divider my-2"
  }), _c('div', {
    staticClass: "partnet-point-show__info__title"
  }, [_vm._v("兌換注意事項")]), _c('ol', [_c('li', [_vm._v("優惠適用於所有寶雅會員 。")]), _c('li', [_vm._v("會員帳戶必須持有該預訂於使用優惠代碼折扣前的足夠里數, 才可應用此優惠代碼。")]), _c('li', [_vm._v("聯營信用卡額外9折里數兌換全球飯店及租車獎勵之優惠，只適用於台灣「亞洲萬里通」聯營信用卡持卡人，並須受「亞洲萬里通」聯營信用卡兌換禮遇項目內之條款及細則約束。")]), _c('li', [_vm._v("此優惠代碼只供會員透過網頁直接使用，並不能通過或經由第三方使用。 ")]), _c('li', [_vm._v("每筆交易只能使用一次優惠代碼，並不能與其他推廣折扣優惠同時使用（聯營信用卡折扣優惠除外）。")]), _c('li', [_vm._v("預訂多於一晚之酒店住宿時，優惠會以每晚房間所需里數平均計算。")]), _c('li', [_vm._v("此優惠代碼只適用於推廣期內進行之網頁預訂，並不可轉讓，任何後續之預訂（包括補購里數及預訂更改 ）將不能享有此優惠。")]), _c('li', [_vm._v("優惠適用於所有寶雅會員 。")]), _c('li', [_vm._v("會員帳戶必須持有該預訂於使用優惠代碼折扣前的足夠里數, 才可應用此優惠代碼。")]), _c('li', [_vm._v("聯營信用卡額外9折里數兌換全球飯店及租車獎勵之優惠，只適用於台灣「亞洲萬里通」聯營信用卡持卡人，並須受「亞洲萬里通」聯營信用卡兌換禮遇項目內之條款及細則約束。")]), _c('li', [_vm._v("此優惠代碼只供會員透過網頁直接使用，並不能通過或經由第三方使用。 ")]), _c('li', [_vm._v("每筆交易只能使用一次優惠代碼，並不能與其他推廣折扣優惠同時使用（聯營信用卡折扣優惠除外）。")]), _c('li', [_vm._v("預訂多於一晚之酒店住宿時，優惠會以每晚房間所需里數平均計算。")]), _c('li', [_vm._v("此優惠代碼只適用於推廣期內進行之網頁預訂，並不可轉讓，任何後續之預訂（包括補購里數及預訂更改 ）將不能享有此優惠。")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-text-xs mb-3"
  }, [_vm._v("可用點數 "), _c('span', {
    staticClass: "s-text-secondary s-text-xl"
  }, [_vm._v("5,250")])]);
}]

export { render, staticRenderFns }